// extracted by mini-css-extract-plugin
export default {"BudgetCard":"BudgetCard_BudgetCard__RJRoI"};